import { Edit, Eye, EyeOff } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Post } from '../../../types/blog';

type PostActionsProps = {
  post: Post;
  isAuthor: boolean;
  onStatusChange?: (status: 'draft' | 'published') => void;
  isStatusUpdating?: boolean;
};

export default function PostActions({ 
  post, 
  isAuthor,
  onStatusChange,
  isStatusUpdating 
}: PostActionsProps) {
  if (!isAuthor) return null;

  return (
    <div className="flex items-center gap-3">
      <Link
        to={`/admin/content/edit/${post.id}`}
        className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-indigo-600 bg-indigo-50 rounded-md hover:bg-indigo-100"
      >
        <Edit className="w-4 h-4 mr-1" />
        编辑
      </Link>
      
      <button
        onClick={() => onStatusChange?.(post.status === 'draft' ? 'published' : 'draft')}
        disabled={isStatusUpdating}
        className={`
          inline-flex items-center px-3 py-1.5 rounded-md text-sm font-medium
          ${post.status === 'published' 
            ? 'bg-green-50 text-green-600 hover:bg-green-100' 
            : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
          }
          ${isStatusUpdating ? 'opacity-50 cursor-not-allowed' : ''}
        `}
      >
        {post.status === 'published' ? (
          <>
            <Eye className="w-4 h-4 mr-1" />
            已发布
          </>
        ) : (
          <>
            <EyeOff className="w-4 h-4 mr-1" />
            草稿
          </>
        )}
      </button>
    </div>
  );
}